module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.svg?e54c6ae126dd37d48c47dc1aa75cb54e";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.svg
// module id = fzpB
// module chunks = 29